<template>
  <button @click="openLightbox" type="button">
    <slot />
  </button>
</template>

<script setup>
import { Lightbox } from '@3pc/lightbox-photoswipe';
import { toRefs, computed } from 'vue';
import { uuid } from 'vue-uuid';
import { useSharedState } from '@composables/use-shared-state';

const props = defineProps({
  galleryKey: {
    type: String,
    default: uuid.v1(),
  },
  src: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  caption: {
    type: String,
    default: '',
  },
  copyright: {
    type: String,
    default: '',
  },
});

const { galleryKey, src, width, height, caption, alt, copyright } =
  toRefs(props);

const { state } = useSharedState({ id: `lightbox-${galleryKey.value}` });

const dataSource = {
  caption: caption.value,
  alt: alt.value,
  copyright: copyright.value,
  width: width.value,
  height: height.value,
  src: src.value,
};

const initGallery = () => {
  state.dataSourceList = [];
};

const addDataSoureToGallery = dataSource => {
  state.dataSourceList.push(dataSource);
};

!state.dataSourceList && initGallery();
addDataSoureToGallery(dataSource);

const index = computed(() => {
  return state.dataSourceList.indexOf(dataSource);
});

const openLightbox = () => {
  if (state.photoswipe) state.photoswipe.pswpLightboxInstance.destroy();
  state.photoswipe = new Lightbox({ dataSource: state.dataSourceList });
  state.photoswipe.init();
  state.photoswipe.pswpLightboxInstance.loadAndOpen(index.value);
};
</script>
